<template>
  <div class="left-tree">
    <div class="title">
      <el-button v-if="addRuleShow" type="primary" plain icon="el-icon-plus" size="small" @click="addRule">
        新建拆分规则
      </el-button>
    </div>

    <div v-loading="loading" class="group">
      <el-tree ref="refTree" node-key="id" :props="props" :data="frameTree" :expand-on-click-node="true"
        :default-expanded-keys="defaultExpandKeys" highlight-current class="tree_1" @node-click="handleNodeClick">
        <template #default="{ data, node }">
          <div class="custom-tree-node">
            <span :style="{ 'padding-right': node.level > 1 ? '35px' : '0' }" class="left_tree_item">
              <span class="textAll">{{ data.name }}</span>
              <span v-if="node.level > 1" class="left_tree_item_btn">
                <i v-if="editRuleShow" class="el-icon-edit-outline" @click="editRule(data)"></i>
                <i v-if="delRuleShow" class="el-icon-delete" @click="delRule(data)"></i>
              </span>
            </span>
          </div>
        </template>
      </el-tree>
    </div>

    <el-dialog v-dialogDrag :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
      :title="visibleTitle" width="700px">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="top" size="small">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input ref="ruleName" v-model.trim="ruleForm.ruleName" maxlength="50" show-word-limit placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <el-form-item label="所属专业" prop="specId">
          <el-select v-model="ruleForm.specId" clearable filterable placeholder="请选择所属专业" style="width: 100%" :disabled="visibleTitle=='编辑规则'" @change="changeSpec">
            <el-option v-for="item in specList" :key="item.specId" :label="item.specName" :value="item.specId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="saveRule">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const Ruleform = () => ({
  clientType: 0,
  enterpriseId: "",
  ruleName: "",
  specId: "",
  specName: "",
  id: ""
});
import { mapState } from "vuex";
import layerDetachFileService from "@/CommonDP/service/layerDetachFile-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  data() {
    return {
      visible: false,
      loading: false,
      props: {
        children: "children",
        label: "name"
      },
      ruleForm: Ruleform(),
      rules: {
        ruleName: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        specId: [{ required: true, message: "请选择所属专业", trigger: "change" }]
      },
      specList: [],
      defaultExpandKeys: [],
      currentNodeData: {},
      frameTree: [],
      visibleTitle: '新增规则',
      addRuleShow: checkPermission(this.$allPerms.LAYERDETACHFILE_ADDRULE),
      editRuleShow: checkPermission(this.$allPerms.LAYERDETACHFILE_EDITRULE),
      delRuleShow: checkPermission(this.$allPerms.LAYERDETACHFILE_DELRULE)
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    this.getFrameTree();
  },
  methods: {
    changeSpec(val) {
      this.ruleForm.specName = this.specList.find((ele) => ele.specId === val).specName;
    },
    getFrameTree() {
      this.frameTree = [];
      this.loading = true;
      layerDetachFileService.splitRuleGetList(this.enterpriseId).then(({ data }) => {
        this.loading = false;
        this.specList = data || [];
        const array = data;
        for (const item of array) {
          if (item.children && item.children.length > 0) {
            item.children = item.children.map(a => {
              return {
                name: a.ruleName,
                ...a
              };
            });
            this.frameTree.push(item);
          } else {
            this.frameTree.push(item);
          }
        }
        if (this.currentNodeData.id) {
          this.$nextTick(() => {
            if (this.$refs.refTree) this.$refs.refTree.setCurrentKey(this.currentNodeData.id);
          });
        }
      });
    },

    handleNodeClick(data, node) {
      this.currentNodeData = data;
      this.$emit("onChange", { data, node });
    },

    addRule() {
      this.visible = true;
      this.visibleTitle = '新增规则';
      this.$nextTick(() => {
        this.ruleForm = Ruleform();
        this.ruleForm.id = "";
        this.$refs.ruleName.focus();
        this.$refs.ruleForm.resetFields();
        const { currentNodeData } = this;
        if (currentNodeData) {
          const { specId, specName } = currentNodeData;
          this.ruleForm.specId = specId;
          this.ruleForm.specName = specName;
        } else {
          this.ruleForm.specId = "";
          this.ruleForm.specName = '';
        }
      });
    },

    async editRule(data) {
      this.visible = true;
      this.ruleForm = Ruleform();
      await this.$nextTick();
      this.$refs.ruleForm.resetFields();
      this.visibleTitle = '编辑规则';
      this.ruleForm = { ...data };
      this.ruleForm.clientType = 0;
    },

    async delRule({ id }) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        await layerDetachFileService.splitRuleDelete(id);
        this.currentNodeData = {};
        this.getFrameTree();
        this.$message.success("删除成功");
        this.$emit("empty");
      });
    },

    async saveRule() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.ruleForm.enterpriseId = this.enterpriseId;
          const { id } = this.ruleForm;
          console.log(this.ruleForm, 'this.ruleForm');
          !id ? await layerDetachFileService.splitRuleAdd(this.ruleForm) : await layerDetachFileService.splitRuleUpdate(this.ruleForm);
          this.$message.success("保存成功");
          this.getFrameTree();
          this.visible = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.left-tree {
  height: 100%;
  .group {
    overflow: auto;
    height: calc(100% - 100px);
    .tree_1 {
      font-size: 14px;
    }
    .left_tree_item {
      display: flex;
      align-items:flex-end;
      &_btn {
        position: absolute;
        right: 5px;
        visibility: hidden;
        i {
          cursor: pointer;
          font-size: 14px;
        }
      }
      &:hover {
        .left_tree_item_btn {
          visibility: visible;
        }
      }
    }
  }
  .textAll {
    width: 140px;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .title {
    text-align: center;
    padding: 15px 0;
    border-bottom: 1px solid #ebefff;
  }
}
</style>
